var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.290329 14.3079C-0.0967523 14.695 -0.0967523 15.3226 0.290329 15.7097C0.67741 16.0968 1.30499 16.0968 1.69207 15.7097L3.79469 13.6071C4.18177 13.22 4.18177 12.5924 3.79469 12.2053C3.40761 11.8182 2.78003 11.8182 2.39295 12.2053L0.290329 14.3079ZM1.69206 0.290311C1.30497 -0.0967712 0.677392 -0.0967712 0.290311 0.290311C-0.09677 0.677392 -0.0967706 1.30497 0.290311 1.69206L6.59817 7.99991L5.19642 9.40166C4.80934 9.78874 4.80934 10.4163 5.19642 10.8034C5.5835 11.1905 6.21108 11.1905 6.59817 10.8034L8.70078 8.70078C9.08786 8.3137 9.08786 7.68612 8.70078 7.29904L1.69206 0.290311Z",
    fill: "#1F2D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.ae3f1259fd50d879953696375d25aca0.svg";
export { ForwardRef as ReactComponent };